import React from "react";
import { Select } from "chakra-react-select";
const fontStyles = {
    option: (styles, { isDisabled, data }) => {
        return Object.assign(Object.assign({}, styles), { fontFamily: data.value, cursor: isDisabled ? "not-allowed" : "default", ":active": {
                fontFamily: data.value,
            } });
    },
    singleValue: (styles, { data }) => {
        return Object.assign(Object.assign({}, styles), { fontFamily: data.value });
    },
};
export const FontPicker = ({ selectedFont, onSelect, fonts, onOpen, }) => {
    return (React.createElement(Select, { size: "sm", isMulti: false, value: {
            label: selectedFont,
            value: selectedFont,
        }, onChange: (newValue) => { var _a; return onSelect((_a = newValue === null || newValue === void 0 ? void 0 : newValue.value) !== null && _a !== void 0 ? _a : ""); }, chakraStyles: fontStyles, options: fonts.map((font) => ({
            label: font.name,
            value: font.name,
        })), onMenuOpen: onOpen }));
};
